/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */

// import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Subject, Observable } from 'rxjs';
import { CommonService } from 'app/shared/services/common.service';

@Injectable()
export class DistributorOrdersService {
  private reportUrl: string = environment.host + '/report/Orders';
  private masterColumnsAndFiltersUrl: string = environment.host + '/compensation/analytics/metadata';
  private currentPeriodUrl: string = environment.host + '/currentperiod';
  private applyFiltersUrl: string = environment.host + '/participant/teamOrder';
  private ArchivedapplyFiltersUrl: string = environment.host + '/participant/archive/teamOrder';
  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;

  constructor(private http: HttpClient, private commonService: CommonService) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  // getOrdersByParticpantId(particpantId, pageNo, pageSize, payload) {
  //   return this.http.post(environment.host + '/participant/' + particpantId + '/OrderDetails' + '?page=' + pageNo + '&size=' + pageSize, payload).pipe(
  //     map(response => response))
  // }

  public getGroupOrdersByClientId(pageNo: any, pageSize: any, payload: any, groupId: any, periodPosition: any) {
    const routePath = this.commonService.ActivatedSideSubMenu === 'Archived';
    if (routePath && payload.sourceTypes.includes('Order')) {
      payload.sourceTypes = payload.sourceTypes.map((type: any) => (type === 'Order' ? 'OrderArchive' : type));
    }
    const filterURL = `${
      routePath ? this.ArchivedapplyFiltersUrl : this.applyFiltersUrl
    }?pageMaxId=${pageNo}&group=${groupId}&size=${pageSize}&currentPeriod=${periodPosition}`;
    return this.http.post(filterURL, payload);
  }

  public getTotalOrdersCount() {
    return this.http.get<any>(environment.host + '/ordersCount');
  }

  public getReportDefinition() {
    const url = this.reportUrl;
    return this.http.get(url).toPromise();
  }

  /*Columns */
  public loadMasterColumnsAndFilters() {
    return this.http.get(this.masterColumnsAndFiltersUrl).toPromise();
  }

  public getCurrentPeriod(regionCode: string) {
    if (regionCode) {
      return this.http.get(this.currentPeriodUrl + '?regionCode=' + regionCode).toPromise();
    } else {
      return this.http.get(this.currentPeriodUrl).toPromise();
    }
  }
}
